var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"influx-line-wrapper"},[_c('e-chart',{attrs:{"options":_vm.optionsC,"theme":"light"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }